module.exports = __webpack_public_path__ + "static/media/privacy-zh.1086e49b.md";